export default class Model {
	constructor(panelItems, pluses, categories, engines, cart, navigation) {
		this._categories = categories;
		this._engines = engines;
		this._panelItems = this.initPanelItems(panelItems);
		this._pluses = pluses;
		this._cartItems = [];
		this._cart = cart;
		this._navigation = navigation;

		// Structure data to search more efficiently
		this._searchDetailByCategoriesStructure =
			this.initSearchDetailByCategoryId(panelItems);
	}

	set panelItems(items) {
		this._panelItems = this.initPanelItems(items);
	}

	get panelItems() {
		return this._panelItems;
	}

	get pluses() {
		return this._pluses;
	}

	get categories() {
		return this._categories;
	}

	get engines() {
		return this._engines;
	}

	get cartItems() {
		if (this._cartItems.length === 0) {
			this.generateCartItems();
		}

		return this._cartItems;
	}

	get cart() {
		return this._cart;
	}

	get searchDetailByCategoriesStructure() {
		return this._searchDetailByCategoriesStructure;
	}

	get navigation() {
		return this._navigation;
	}

	/**
	 * Generates a list of card items.
	 * This approach allows defining various types as cart items, promoting decoupling.
	 * Type example: { type: "bookmark", id: "", text: {en: "", de: ""}, relationType: "solution", relationId: "" }
	 * @returns {Array} List of card items.
	 */
	generateCartItems() {
		this._cartItems = [];

		const traverse = (items, parentIndex = "") => {
			items.forEach((item, index) => {
				let currentId = parentIndex + index.toString();

				this._cartItems.push({
					type: "bookmark",
					id: Number(currentId),
					text: item.title,
					relationType: item.type,
					relationId: item.id,
				});

				if (item.children && item.children.length > 0) {
					traverse(item.children, currentId);
				}
			});
		};

		traverse(this.panelItems);
	}

	initPanelItems(panelitems) {
		const categoryMap = this.categories.reduce((map, category) => {
			map[category.id] = category;
			return map;
		}, {});

		const assignCategories = (item) => {
			if (item.categories && item.categories.length > 0) {
				item.categories = item.categories.map(
					(categoryId) => categoryMap[categoryId],
				);
			}
			if (item.children && item.children.length > 0) {
				item.children.forEach(assignCategories);
			}
		};

		panelitems.forEach(assignCategories);
		return panelitems;
	}

	initSearchDetailByCategoryId(panelItems) {
		const categories = {};
		panelItems.forEach((item) => {
			item.children.forEach((child) => {
				child.categories.forEach((category) => {
					if (!(category.id in categories)) {
						categories[category.id] = [];
					}
					child["parentId"] = item.id;
					categories[category.id].push(child);
				});
			});
		});
		return categories;
	}
}
